import { motion } from "framer-motion";
import { Calendar, MapPin } from "lucide-react";
import SectionHeader from "./SectionHeader";

// Upcoming Dates — features 24 Hours of Peace (Newark, Aug 28-29, 2026)
// with Freeway performing Friday. The source flyer is REFERENCE ONLY and is
// NOT displayed anywhere; card is built entirely in the site's own design.
export default function Tour() {
  return (
    <section id="tour" data-testid="tour-section" className="relative bg-black text-white">
      <SectionHeader src="/assets/headers/dates.jpg" alt="Upcoming Dates" fadeTo="black" />
      <div className="px-4 md:px-10 max-w-[1400px] mx-auto pb-20 md:pb-28 -mt-10">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="mb-10 relative z-10">
          <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#F4C10A] mb-3">23rd Anniversary Tour</div>
          <h2 className="font-wide text-white uppercase text-4xl sm:text-5xl md:text-6xl">Upcoming Dates</h2>
        </motion.div>

        {/* UP NEXT — 24 Hours of Peace */}
        <div data-testid="up-next-card" className="bg-[#F4C10A] text-black p-8 md:p-12">
          <div className="grid md:grid-cols-[auto_1fr] gap-6 md:gap-10 items-start">
            <div>
              <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-black/60 mb-3">Up Next</div>
              <div className="font-wide uppercase text-black leading-[0.95] text-4xl sm:text-5xl md:text-6xl">
                24 Hours<br/>of Peace
              </div>
              <div className="mt-4 font-body italic text-black/80 text-sm md:text-base">Love. Unity. Safely having fun.</div>
            </div>
            <div className="border-l-0 md:border-l md:border-black/25 md:pl-10">
              <div className="font-mono text-[10px] tracking-[0.35em] uppercase text-black/70 mb-2">Freeway Performs</div>
              <div className="font-wide uppercase text-black text-2xl md:text-3xl">Friday · Aug 28, 2026</div>
              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex items-start gap-3"><Calendar className="w-4 h-4 mt-1 flex-shrink-0"/><div><div className="font-mono text-[10px] tracking-[0.3em] uppercase text-black/60">Event Window</div><div className="font-display uppercase text-sm mt-1">Aug 28 – Aug 29, 2026 · 24 Hrs · 6PM – 6PM</div></div></div>
                <div className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-1 flex-shrink-0"/><div><div className="font-mono text-[10px] tracking-[0.3em] uppercase text-black/60">Location</div><div className="font-display uppercase text-sm mt-1">Downtown Newark<br/>Halsey & Market</div></div></div>
              </div>
              <div className="mt-6 pt-5 border-t border-black/20">
                <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-black/60 mb-1">Presented By</div>
                <div className="font-body text-sm text-black/85">City of Newark · Mayor Ras J. Baraka and the Municipal Council</div>
                <div className="mt-3 font-mono text-[10px] tracking-[0.3em] uppercase text-black/60">Follow @24hrsofpeace for the artist lineup</div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 bg-white text-black py-6 text-center font-mono text-[11px] tracking-[0.35em] uppercase" data-testid="more-dates-tba">More Dates Coming Soon</div>
      </div>
    </section>
  );
}
